import React from "react"
import { Anchor } from "../../../app/components/anchor"
import PageHead from "../../../components/head/PageHead"
import PageNav from "../../../storyblok/sections/PageNav"
import { urlifyComplexName } from "../../../constants/stateCityDictionary"
import Footer from "../../../storyblok/static/Footer"
import { petShippingSchema } from "../../../seo/schemas"
import Breadcrumb from "../../../components/breadcrumbs"
import characteristics from "../../../constants/breed-characteristics/breed-characteristics-content.json"

export default function PetShipping({
  data,
}: {
  data: { [key: string]: string }[]
}) {
  return (
    <>
      <PageNav
        noBlok
        route={"shipments/new/"}
        buttonLabel="Get Pet Transportation Quotes"
      />
      <PageHead
        title={"Learn More About Popular Dog Breeds"}
        description={
          "What breed is best for your family? Browse our index of popular dog breeds to help you find your best buddy!"
        }
      >
        {petShippingSchema}
      </PageHead>

      <div className="md:pt-22 xl:mt-24 px-4 lg:px-10 lg:mx-auto lg:max-w-[1300px]">
        <div className="mt-16 pt-8">
          <Breadcrumb
            items={[
              { name: "Home", href: "/" },

              { name: "All Dog Breeds", href: "/pets/dogs/all-breeds" },
            ]}
          />
        </div>
        <div className="pb-10 mb-10">
          <h1 className="text-3xl md:text-4xl font-montserrat">
            All Dog Breeds
          </h1>
          <div className="mb-8">
            <p className="text-lg leading-8">
              Experts estimate that there are around 500 different dog breeds
              across the globe. From energetic sporting dogs to adorable toy
              breeds to versatile hounds, there is a perfect furry friend for
              every home and lifestyle. But how do you know which type of dog is
              best for you?
            </p>
            <p className="text-lg leading-8">
              Browse our in-depth collection of articles that take a closer look
              at some of the most popular breeds in the United States. Learn
              more about training specific breeds, grooming and health
              recommendations, which breeds are great with kids, and even gear
              and toys for each type of dog.
            </p>
          </div>
          <div>
            <ul className="grid md:grid-cols-3 gap-x-10 gap-y-6 px-0 list-none">
              {/* @ts-ignore */}
              {data.map((item, index) => (
                <li key={`army-${item?.base ?? index}`} className="text-left">
                  <Anchor href={`/pets/dogs/${item.breed}`}>{item.name}</Anchor>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <Footer noBlok />
    </>
  )
}

export const getStaticProps = async () => {
  const breedData = characteristics
    .filter((breed) => breed.animal === "dog")
    .map((breed) => ({
      breed: urlifyComplexName(breed.breed),
      name: breed.breed,
    }))

  return {
    props: {
      data: breedData,
    },
  }
}
